(function ($) {
  var $ = jQuery = $;

  // Produkt Registrierung
  $('#product-registration').submit(function(event) {
    event.preventDefault();

    let $form = $(this);
    let accepts_marketing = $form.find('input[type="checkbox"][name="accepts_marketing"]').prop('checked');
    if (accepts_marketing) {
      saveNewsletterRecipient($form);
    }

    $form.submit();
    // sendRegistration($form);
  });

  function sendRegistration($form)
  {
    let url = $form.attr('action');

    $.ajax({
      url: url,
      type: 'POST',
      contentType: 'application/json',
      data: JSON.stringify($form.serializeArray()),
      success: function(response) {
        // Erfolgreiche Antwort verarbeiten
        console.log('Erfolgreiche Antwort:', response);
      },
      error: function(xhr, status, error) {
        // Fehler bei der AJAX-Anfrage
        console.error('AJAX-Fehler:', error);
      }
    });
  }

  function saveNewsletterRecipient($form)
  {
    let url = '/contact';

    $.ajax({
      url: url,
      type: 'POST',
      dataType: 'json',
      data: JSON.stringify($form.serializeArray()),
      success: function(response) {
        // Erfolgreiche Antwort verarbeiten
        console.log('Neuer Newsletter-Empfänger erstellt:', response);
      },
      error: function(xhr, status, error) {
        // Fehler bei der AJAX-Anfrage
        console.error('Fehler beim Erstellen des Newsletter-Empfängers:', error);
      }
    });
  }

})(theme.jQuery);
